import { createFileRoute } from "@tanstack/react-router";
import { OfficeEditorPage } from "@/features/office/OfficeEditorPage";

export const Route = createFileRoute("/_app/files/$file/office")({
  validateSearch: (search: Record<string, unknown>): { mode: "edit" | "view" } => ({ mode: search.mode === "view" ? "view" : "edit" }),
  component: Page,
});

function Page() {
  const { file } = Route.useParams();
  const { mode } = Route.useSearch();
  return <OfficeEditorPage fileId={file} mode={mode} />;
}
